<template>
  <div class="panel_saleView">
    <div class="panel_content" v-show="!showList">
      <div class="panel_left">
        <div @click="type = '1'" :class="type == '1' ? 'active' : ''">
          宠物权益
        </div>
        <!-- <div @click="type = '2'" :class="type == '2' ? 'active' : ''">
          VIP权益
        </div> -->
      </div>
      <!-- <div v-show="type == '2'" @click="showList = true">领取记录</div> -->
    </div>
    <div>
      <panelPetVip v-show="type == '1' && !showList"></panelPetVip>
      <!-- <panelVip v-show="type == '2' && !showList"></panelVip> -->
    </div>
    <div>
      <!-- 领取列表 -->
      <!-- <panelReceiveList v-show="showList" @getback="getBack"></panelReceiveList> -->
    </div>
  </div>
</template>
<script>
import panelPetVip from "./panel_huiyuanquanyi.vue";
// import panelVip from "./panel_vipInterests.vue";
// import panelReceiveList from "./panel_receiveList.vue";

export default {
  components: {
    panelPetVip,
    // panelVip,
    // panelReceiveList,
  },
  data() {
    return {
      type: "1",
      showList: false,
    };
  },
  methods: {
    getBack(){
        this.showList=false;
        this.type='2';
    }
  },
};
</script>
<style scoped lang="scss">
.panel_saleView {
  width: 100%;
  height: 100%;
  border-radius: 4px;
  padding: 30px 20px;
  box-sizing: border-box;
  background: #fff;
  .panel_content {
    display: flex;
    margin-bottom: 10px;
    justify-content: space-between;
    cursor: pointer;
    font-size: 14px;
    .panel_left {
      display: flex;
      & > div:nth-child(1) {
        margin-right: 60px;
      }
    }
    .active {
      color: $mainColor;
      padding-bottom: 10px;
      font-weight: 600;
      border-bottom: 3px solid $mainColor;
    }
  }
}
</style>